module.exports = __webpack_public_path__ + "static/media/event-services-img34.fdf9fa0d.jpg";